export default __webpack_public_path__ + "2c70a8754e42e215e45ca988b0973cfb.jpg";